import { FIRST_TREE_LEVEL, ROW_TOGGLE_SIZE, TRUNK_X } from './tree.consts';
import { GetTrunkLeftParams, ResolveTreeBranchParams, TreeBranch } from './tree.types';

export const getTrunkLeft = ({
  level,
  cellShiftInLevels,
  levelWidth,
  leadingPadding,
}: GetTrunkLeftParams): number =>
  (level - cellShiftInLevels - 1) * levelWidth + leadingPadding + ROW_TOGGLE_SIZE / 2 - TRUNK_X;

export const resolveTreeBranch = ({
  isChild,
  depth,
  trunkContinuations,
  isFirstLevelTreeHidden,
}: ResolveTreeBranchParams): TreeBranch => {
  if (!isFirstLevelTreeHidden) {
    return { hasTreeBranch: isChild, trunkContinuations };
  }

  return {
    hasTreeBranch: isChild && depth !== FIRST_TREE_LEVEL,
    trunkContinuations: trunkContinuations.map((hasTrunk, level) =>
      level === FIRST_TREE_LEVEL - 1 ? false : hasTrunk,
    ),
  };
};
